import type { ModuleDefinition } from '@/shared/types/module';
import { accountModule } from '@/modules/account';
import { dashboardModule } from '@/modules/dashboard';
import { userManagementModule } from '@/modules/user-management';

const modules: ModuleDefinition[] = [dashboardModule, accountModule];

if (__FEATURE_ELABEL__) {
  modules.push((await import('@/modules/elabel')).elabelModule);
}
if (__FEATURE_DEVICE__) {
  modules.push((await import('@/modules/device')).deviceModule);
}
if (__FEATURE_ALERT__) {
  modules.push((await import('@/modules/alert')).alertModule);
}
if (__FEATURE_NOTIFICATIONS__) {
  modules.push((await import('@/modules/notification')).notificationModule);
}
if (__FEATURE_NATIVE__) {
  modules.push((await import('@/modules/native')).nativeModule);
}

modules.push(userManagementModule);
export const activeModules = modules;
